























import Vue from "vue";
import isEmpty from "lodash-es/isEmpty";
import { WidgetQueryType } from "./Dashboard.vue";
import WidgetDetails from "./WidgetDetails.vue";
// werkt niet in IE: import TransitionExpand from "../../components/TransitionExpand.vue";

export default Vue.extend({
  props: {
    widgetQueryType: { required: true },
    drilldownGroupBy: { required: true, type: String },
    stackedDetailsLevelData: {
      required: true,
      default: () => [] as any[]
    },
    xsonly: {
      type: Boolean,
      default: false
    },
    smonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showArrowDown(stackIndex: number): boolean {
      if (isEmpty(this.stackedDetailsLevelData)) return false;
      return (
        this.stackedDetailsLevelData.length > 1 &&
        this.stackedDetailsLevelData.length - stackIndex > 1
      );
    },
    onRowSelected(data: any, stackIndex: any) {
      this.$emit("row-selected", {
        StackId: stackIndex,
        IsTotalRow: data.IsTotalRow,
        Id: data.Id
      });
    },
    onRowDeselected(event: any, stackIndex: any) {
      this.$emit("row-deselected", {
        StackId: stackIndex
      });
    },
    gridTitle(stackIndex: number): string {
      if (stackIndex === 1) return `${this.$i18n.t("source")}`;
      if (stackIndex === 2) return `${this.$i18n.t("leadkind")}`;

      switch (this.drilldownGroupBy) {
        case "ZoneId":
          return `${this.$i18n.t("region")}`;
        case "VestigingId":
          return `${this.$i18n.t("branch")}`;
        case "AutobedrijfId":
          return `${this.$i18n.t("autobedrijf")}`;
        default:
          return this.drilldownGroupBy;
      }
    }
  },

  components: {
    WidgetDetails
  }
});
